import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  background: #f0fbff;
`;
